import React, { FC, useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { Layout } from "@lookiero/sty-psp-ui";
import { useViewOrderById } from "../../behaviors/useViewOrderById";
import { ReturnConfirmation as ReturnConfirmationTemplate } from "../../components/templates/returnConfirmation/ReturnConfirmation";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { Routes } from "../../routing/routes";

interface ReturnConfirmationProps {
  readonly layout: Layout;
  readonly onShowReturnInstructions: (serviceId: string) => void;
}

const ReturnConfirmation: FC<ReturnConfirmationProps> = ({ layout, onShowReturnInstructions }) => {
  const { orderId } = useParams();
  const orderDetails = useViewOrderById(orderId as string);

  const { basePath } = useStaticInfo();
  const navigate = useNavigate();
  const handleOnPressExploreYourLooks = useCallback(() => navigate(`${basePath}/${Routes.HOME}`), [basePath, navigate]);

  const handleOnShowReturnInstructions = useCallback(() => {
    if (orderDetails) {
      onShowReturnInstructions(orderDetails.serviceId);
    }
  }, [onShowReturnInstructions, orderDetails]);

  const handleOnClose = useCallback(() => navigate(`${basePath}/${Routes.ORDERS}`), [basePath, navigate]);

  return (
    <ReturnConfirmationTemplate
      layout={layout}
      onClose={handleOnClose}
      onPressExploreYourLooks={handleOnPressExploreYourLooks}
      onPressShowReturnInstructions={handleOnShowReturnInstructions}
    />
  );
};

export { ReturnConfirmation };
